import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

interface ParkingType {
  id: number;
  name: string;
}

const fetchParkingTypes = async (): Promise<ParkingType[]> => {
  const response = await api.get<ParkingType[]>('/api/parking-types');
  return response.data;
};

export const useParkingTypes = () => {
  const {
    data: parkingTypes = [],
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['parkingTypes'],
    queryFn: fetchParkingTypes,
    staleTime: 5 * 60 * 1000, // 5 minutos
    retry: 1,
    refetchOnWindowFocus: false
  });

  return {
    parkingTypes,
    isLoading,
    error: error?.message || null,
    refetch
  };
}; 